import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = still checking session, false = not authenticated, object = user
  const [user, setUser] = useState(null);

  useEffect(() => {
    let mounted = true;
    api
      .get("/auth/me")
      .then((r) => mounted && setUser(r.data))
      .catch(() => mounted && setUser(false));
    return () => {
      mounted = false;
    };
  }, []);

  const login = useCallback(async (email, password, expectedRole) => {
    const { data } = await api.post("/auth/login", { email, password, expected_role: expectedRole });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // clear local state regardless
    }
    setUser(false);
  }, []);

  const hasPermission = useCallback(
    (perm) => Boolean(user && user.permissions && user.permissions.includes(perm)),
    [user]
  );

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
